import { ReservedWords } from "./reservedWords";

export function getContentUrl(options: {
  domain?: string;
  lang: string;
  contentType: ReservedWords;
  segments: string[];
}): string {
  const { domain, lang, contentType, segments } = options;
  const isPath = !!domain;

  if (segments?.length === 1 && segments[0].startsWith("#")) {
    return segments[0];
  }

  const parts = [domain, lang, contentType, segments?.join("/")];
  const url = parts.filter((part) => !!part).join("/");

  return (isPath ? "" : "/") + url + "/";
}
